export const ACTIONS_SECTION_DESCRIPTION =
  "Manage and customize your business's Place Actions to enhance how customers interact with your profile on Google. Add booking, ordering, or other action links to drive engagement and streamline customer experiences.";

export const NO_SETTINGS_WARNING_MESSAGE =
  'No Place Actions settings are configured for this location. Please go to the Connection tab to set up your location before managing Place Actions.';

export const PLACE_ACTIONS_PUSH_NOT_ENABLED_WARNING_MESSAGE =
  'Place Actions syncing to Google is not enabled for this account. To manage action links for your business, please first enable syncing in the Connection tab. This will allow you to customize how customers take actions on Google.';

export const ACTION_SET = 'set';
export const ACTION_DELETE = 'delete';
